import store from '@/store'

export default [
  {
    path: '/unit-of-measures',
    name: 'unit-of-measure',
    meta: { requiresAuth: true },
    component: () => import('@/pages/uom-category/index.vue')
  },
  {
    path: '/unit-of-measures/create',
    name: 'unit-of-measure-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/uom-category/create.vue')
  },
  {
    path: '/unit-of-measures/:id',
    name: 'unit-of-measure-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/uom-category/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('uomCategory/find', to.params.id)
      next()
    }
  }
]
